import axios from 'axios';
import { USERS } from '../constantes';
export const GET_USERS = "GET_USERS";
export const POST_USER = "POST_USER";


export const getUsers = () => async dispatch => {
    await axios.get(USERS, {withCredentials:true})
        .then((res) => {
            dispatch({
                type: GET_USERS,
                payload: res.data
            })
            console.log(res.data)
        })
        .catch((err) => {console.log(err)})
}

export const postUser = (payload) => async dispatch => {
    try {
        await axios.post(USERS, payload, {withCredentials:true})
        .then( res => {
            dispatch({
                type: POST_USER,
                payload: res.data
            })
            console.log(res.data)
        })       
    } catch (error) {
        return (error)
    }
}





